import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Mee › Tổng quan (Overview.tsx). Mã nghiệp vụ và dữ liệu mẫu không dịch.
addMessages('vi', {
  'ov.clockMissing': 'Chấm công hôm nay còn thiếu',
  'ov.teamPend': '{n} đơn của nhóm chờ duyệt',
  'ov.approve': 'Duyệt →',
  'ov.todayAria': 'Chấm công hôm nay',
  'ov.today': 'Hôm nay',
  'ov.shiftLb': 'Ca theo lịch công ty (tblClientInfo)',
  'ov.inRadius': 'Trong bán kính điểm làm việc đã gán',
  'ov.office': 'VP Cộng Hòa · {d} m',
  'ov.offDay': 'Hôm nay không phải ngày làm việc',
  'ov.shiftAria': 'Ca {s}, đã qua {p}%',
  'ov.in': 'Vào',
  'ov.out': 'Ra',
  'ov.presTitle': 'Có mặt · trừ nghỉ trưa theo lịch công ty',
  'ov.pres': 'Có mặt',
  'ov.clockedOut': 'Đã chấm ra {h}',
  'ov.clockOut': 'Chấm công ra',
  'ov.faceToast': 'Chấm bằng khuôn mặt · GPS chưa có dữ liệu thật',
  'ov.faceBtn': 'Chấm bằng khuôn mặt · GPS',
  'ov.leaveAria': 'Phép năm còn {l} trên {q} ngày · {p} ngày đang chờ duyệt',
  'ov.leave': 'Phép năm 2026',
  'ov.left': 'Còn lại',
  'ov.pending': 'Chờ duyệt',
  'ov.used': 'Đã dùng',
  'ov.slipAria': 'Phiếu lương gần nhất',
  'ov.salary': 'Lương {m}',
  'ov.onlyYou': 'Chỉ mình bạn xem được',
  'ov.net': 'Thực nhận',
  'ov.noPay': 'Chưa có dữ liệu lương',
  'ov.hide': 'Ẩn',
  'ov.show': 'Hiện',
  'ov.noSlip': 'Phiếu lương chưa có dữ liệu',
  'ov.viewSlip': 'Xem phiếu →',
  'ov.pendReq': 'Đơn đang chờ',
  'ov.all': 'Tất cả →',
  'ov.noReq': 'Không có đơn chờ',
  'ov.waiting': 'Chờ {a} · {b}',
  'meeov.todo': 'Việc cần làm',
  'ov.noTodo': 'Không có việc cần làm',
  'ov.noTodoData': 'Việc này chưa có dữ liệu thật',
  'ov.holidays': 'Lễ sắp tới',
  'ov.noHol': 'Chưa có lễ sắp tới',
  'ov.days': '{n} ngày',
  'ov.companyOff': ' · nghỉ riêng công ty',
  'ov.ongoing': 'Đang diễn ra',
  'ov.inDays': 'Còn {n} ngày',
  'ov.now': 'Nay',
  'ov.adv': 'Tạm ứng của tôi',
  'ov.noEmp': 'Danh sách phiếu EMP chưa có dữ liệu',
  'ov.emp': 'Phiếu EMP',
  'ov.title': 'Tổng quan',
  'ov.create': 'Tạo đơn',
  'ov.empty': 'Chưa có dữ liệu',
  'ov.err': 'Không tải được dữ liệu của tôi',
  'ov.emptyDesc': 'Tài khoản mới: chấm công, đơn và phiếu lương sẽ hiện ở đây sau ngày làm việc đầu tiên.',
  'ov.errDesc': 'Mất kết nối lúc 08:42 · lần chấm công tiếp theo được ghi tạm trên máy và gửi lại khi có mạng.',
  'ov.retry': 'Thử lại',
  'ov.clockIn': 'Chấm công vào',
});
addMessages('en', {
  'ov.clockMissing': 'Today’s clock-in is incomplete',
  'ov.teamPend': '{n} team requests awaiting approval',
  'ov.approve': 'Approve →',
  'ov.todayAria': 'Today’s check-in',
  'ov.today': 'Today',
  'ov.shiftLb': 'Shift per company schedule (tblClientInfo)',
  'ov.inRadius': 'Within the assigned work-site radius',
  'ov.office': 'Cong Hoa office · {d} m',
  'ov.offDay': 'Today is not a working day',
  'ov.shiftAria': 'Shift {s}, {p}% elapsed',
  'ov.in': 'In',
  'ov.out': 'Out',
  'ov.presTitle': 'Present · minus lunch break per company schedule',
  'ov.pres': 'Present',
  'ov.clockedOut': 'Clocked out at {h}',
  'ov.clockOut': 'Clock out',
  'ov.faceToast': 'Face check-in · GPS has no real data yet',
  'ov.faceBtn': 'Face check-in · GPS',
  'ov.leaveAria': 'Annual leave: {l} of {q} days left · {p} days pending approval',
  'ov.leave': 'Annual leave 2026',
  'ov.left': 'Remaining',
  'ov.pending': 'Pending',
  'ov.used': 'Used',
  'ov.slipAria': 'Latest payslip',
  'ov.salary': 'Salary {m}',
  'ov.onlyYou': 'Only you can see this',
  'ov.net': 'Net pay',
  'ov.noPay': 'No payroll data yet',
  'ov.hide': 'Hide',
  'ov.show': 'Show',
  'ov.noSlip': 'No payslip data yet',
  'ov.viewSlip': 'View payslip →',
  'ov.pendReq': 'Pending requests',
  'ov.all': 'All →',
  'ov.noReq': 'No pending requests',
  'ov.waiting': 'Waiting {a} · {b}',
  'meeov.todo': 'To do',
  'ov.noTodo': 'Nothing to do',
  'ov.noTodoData': 'This item has no real data yet',
  'ov.holidays': 'Upcoming holidays',
  'ov.noHol': 'No upcoming holidays',
  'ov.days': '{n} days',
  'ov.companyOff': ' · company-only day off',
  'ov.ongoing': 'Ongoing',
  'ov.inDays': '{n} days to go',
  'ov.now': 'Now',
  'ov.adv': 'My advances',
  'ov.noEmp': 'The EMP voucher list has no data yet',
  'ov.emp': 'EMP vouchers',
  'ov.title': 'Overview',
  'ov.create': 'New request',
  'ov.empty': 'No data yet',
  'ov.err': 'Could not load my data',
  'ov.emptyDesc': 'New account: check-ins, requests and payslips will appear here after the first working day.',
  'ov.errDesc': 'Connection lost at 08:42 · the next check-in is saved on the device and resent when online.',
  'ov.retry': 'Retry',
  'ov.clockIn': 'Clock in',
});
